export { navigationRef, NavigationService } from './navigation-ref';
export { RootNavigator } from './root-navigator';

export type {
  AuthDrawerParamList,
  AuthDrawerScreenProps,
  PublicScreenParamList,
  PublicScreenProps,
  RootStackParamList,
  RootStackScreenProps,
  UnAuthStackParamList,
  UnAuthStackScreenProps,
} from './types';
